module.exports = __webpack_public_path__ + "static/all-cfaf975ad46508329c881777792e0fcd.gif";